import type { RequestType } from '@product-portal/shared';
import { TYPE_LABELS } from '@/lib/labels';
import { Pill } from './pill';

const TYPE_CLASSES: Record<RequestType, string> = {
  bug: 'bg-type-bug text-type-bug-foreground',
  evolution: 'bg-type-evolution text-type-evolution-foreground',
  help: 'bg-type-help text-type-help-foreground',
};

export function TypeTag({ type }: { type: RequestType }) {
  return <Pill className={TYPE_CLASSES[type]}>{TYPE_LABELS[type]}</Pill>;
}
